import React from "react"
import { graphql } from "gatsby"
import { Section, CmsImage } from "@bw/bits"
import { ContentWithImage as ContentWithImageModule } from "@bw/modules"
import parse from "html-react-parser"

const ContentWithImage = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  backgroundVariant,
  negativeTextColor,
  imageTakesWholeBackground,
  isFollowedByModuleWithBackgroundVariant,
  text,
  textWidth,
  orientation,
  alignement,
  image,
}) => {
  return (
    <Section
      {...{
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
        idAttribute,
        classAttribute,
        negativeTextColor,
        image: imageTakesWholeBackground && image ? (
          <CmsImage src={image.backgroundImage} alt={image?.alt} />
        ) : null,
        focus: image?.has_focus ? image.focus_css : undefined,
      }}
    >
      <ContentWithImageModule
        {...{
          suptitle,
          title,
          subtitle,
          button,
          buttonPosition,
          orientation: orientation?.value,
          alignement: alignement?.value,
          text: text ? parse(text) : undefined,
          textWidth: textWidth?.value ?? 50,
          image: imageTakesWholeBackground ? null : image ? (
            <CmsImage src={image} alt={image?.alt} />
          ) : null,
        }}
      />
    </Section>
  )
}

export const query = graphql`
  fragment ContentWithImageModuleFragment on ContentWithImageModule {
    image {
      alt
      has_focus
      focus_css
      localImage {
        childImageSharp {
          gatsbyImageData(width: 672)
        }
      }
      backgroundImage: localImage {
        childImageSharp {
          gatsbyImageData(width: 2500)
        }
      }
    }
    orientation {
      value
    }
    alignement {
      value
    }
    text
    textWidth {
      value
    }
    imageTakesWholeBackground
    negativeTextColor
  }
`

export { ContentWithImage }